import { render, staticRenderFns } from "./PeopleSport.vue?vue&type=template&id=9c7475f2"
import script from "./peopleSport.js?vue&type=script&lang=js&external"
export * from "./peopleSport.js?vue&type=script&lang=js&external"
import style0 from "./PeopleSport.vue?vue&type=style&index=0&id=9c7475f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports